module.exports = "pegasus_template/assets/preview-23.png";